import React from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useScrollTrigger,
  Container,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface HeaderProps {
  title: React.ReactNode;
  subtitle?: string;
  showBackButton?: boolean;
  onBack?: () => void;
  align?: 'left' | 'center';
  rightSlot?: React.ReactNode;  // For drawer status chip, actions, etc.
  sticky?: boolean;
  elevateOnScroll?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  title,
  subtitle,
  showBackButton = false,
  onBack,
  align = 'center',
  rightSlot,
  sticky = false,
  elevateOnScroll = false,
}) => {
  const trigger = useScrollTrigger({ disableHysteresis: true, threshold: 0 });
  const isCenter = align === 'center';

  return (
    <AppBar
      position={sticky ? 'sticky' : 'static'}
      color="transparent"
      elevation={elevateOnScroll && trigger ? 2 : 0}
      sx={{
        px: { xs: 0 },
        backgroundColor: 'background.paper',
      }}
    >
      <Container
        disableGutters
        sx={{
          width: '100%',
          maxWidth: { xs: '100%', sm: 720, md: 880 },
          mx: 'auto',
        }}
      >
        <Toolbar sx={{ minHeight: 56 }}>
          {showBackButton ? (
            <IconButton edge="start" onClick={onBack} sx={{ mr: 2 }}>
              <ArrowBackIcon />
            </IconButton>
          ) : (
            <Box sx={{ width: 48 }} />
          )}

          <Box sx={{ flexGrow: 1, textAlign: isCenter ? 'center' : 'left' }}>
            {typeof title === 'string' ? (
              <Typography variant="h6" fontWeight={600}>
                {title}
              </Typography>
            ) : (
              title
            )}
            {subtitle && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.2 }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>

          {rightSlot ? <Box ml={1}>{rightSlot}</Box> : <Box sx={{ width: 48 }} />}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
